<template>
    <modal name="create_model" height="auto" scrollable adaptive>
        <app-card :title="$t('Create model')">
            <validation-observer v-slot="{ validate }" slim>
                <form @submit.prevent="store(validate)">
                    <model-form :form="form"/>
                    <div class="form-group row">
                        <div class="col-md-7 offset-md-3 d-flex">
                            <app-button :loading="loading">
                                {{ $t('Save') }}
                            </app-button>
                            <app-button class="ml-2" type="outline-warning" native-type="button" @click="hide">
                                {{ $t('Cancel') }}
                            </app-button>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </app-card>
    </modal>
</template>

<script>
import MakesModelsService from '@services/makesModels.service';
import ModelForm from './components/ModelForm';
import moment from 'moment';

export default {
    data() {
        return {
            form: {
                make_id: null,
                name: null,
            },
            loading: false
        };
    },
    methods: {
        store(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    MakesModelsService.storeModel(this.form).then(res => {
                        this.$toastr.s(this.$t('Saved'));
                        this.loading = false;
                        this.$emit('setModel', {model: res, makeIndex: null});
                        this.hide();
                    });
                }
            });
        },
        hide() {
            this.$modal.hide('create_model');
        }
    },
    components: {
        ModelForm
    }
};
</script>
